export default __webpack_public_path__ + "static/media/sirrahclean-logo.a745ee0b.png";